import React, { useContext, useState } from 'react'
import dynamic from 'next/dynamic'
import { Flex, Box } from 'pcln-design-system'
import HotelsTonight from '../HotelsTonight/HotelsTonight'
import PromoFeatureBox from '../PromoFeatureBox'
import Form from '../Hotels/SearchForm/Form'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { handleSubmitForHotels } from '../Hotels/SearchForm/utils'
import StyledHeading from '../StyledHeading'
import MobileHeaderWrapper from '../MobileHeaderWrapper/MobileHeaderWrapper'
import useMostRecentFutureBooking from '../CustomHooks/useMostRecentFutureBooking'
import CrossSell from '../CrossSell'
import CONTENT from '../../constants/content'
import useSEMSearchHeadline from '../CustomHooks/useSEMSearchHeadline'
import MarketingTout from '../Promos/MarketingTout/MarketingTout'
import useCityNameInFormHeadlineForSEM from '../CustomHooks/useCityNameInFormHeadlineForSEM'
import FindMyTripBanner from '../Hotels/FindMyTripBanner'
import useContentfulSearchFormHeadlines from '../CustomHooks/useContentfulSearchFormHeadlines'
import useCurrentBooking from '../CustomHooks/useCurrentBooking'
import { LOCATION_SEARCH_TYPE } from '../../types'
import useSeti from '../CustomHooks/useSeti'

const PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal'
const SECONDARY_HEADING_FALLBACK = 'Save with exclusive rates'

const ExtendStay = dynamic(() => import('../ExtendStay/ExtendStay'))

export default function HomeMobile() {
  const mostRecentFutureBooking = useMostRecentFutureBooking()
  const {
    signInStatus: { signedIn, passiveSignIn },
    customer: { firstName }
  } = useContext(BootstrapDataContext)

  const extendData = useCurrentBooking()
  const isSignedIn = signedIn || passiveSignIn
  const [location, setLocation] = useState<LOCATION_SEARCH_TYPE | undefined>()
  const prePopHeadline = useCityNameInFormHeadlineForSEM(location)
  const SEMHeadline = useSEMSearchHeadline()
  const form = useContentfulSearchFormHeadlines('searchFormHotels')
  /**
   * TODO: Add these values to contentful
   */
  const headlineVIP = firstName
    ? CONTENT.homepage.vip.headlineWithName.replace('{firstName}', firstName)
    : CONTENT.homepage.vip.defaultHeading
  const subheadline = {
    text: isSignedIn
      ? CONTENT.homepage.hotel.signedInSubHeading
      : form?.mobileSubheadline || SECONDARY_HEADING_FALLBACK
  }

  const headlineValues = {
    text: isSignedIn
      ? headlineVIP
      : prePopHeadline ||
        SEMHeadline ||
        form?.mobileHeadline ||
        PRIMARY_HEADING_FALLBACK
  }

  const CrossSellContent = () => {
    return (
      <>
        {mostRecentFutureBooking ? (
          <CrossSell booking={mostRecentFutureBooking} />
        ) : (
          <PromoFeatureBox />
        )}
      </>
    )
  }

  const HP_EXTEND_YOUR_TRIP_PLACEMENT = useSeti(
    'HP_EXTEND_YOUR_TRIP_PLACEMENT',
    !!extendData
  )
  const hideAboveExtendStay =
    extendData && HP_EXTEND_YOUR_TRIP_PLACEMENT === 'VARIANT'
  return (
    <>
      <MobileHeaderWrapper selectedProductName="Hotels" />
      <Box m={3}>
        <Flex flexDirection="column" mb={3}>
          <StyledHeading {...headlineValues} fontSize={3} tag="h1" />
          <StyledHeading
            color="text.light"
            mt={1}
            fontSize={1}
            {...subheadline}
            tag="h2"
          />
        </Flex>
        <Form onSubmit={handleSubmitForHotels} setLocation={setLocation} />
      </Box>
      {!hideAboveExtendStay && <FindMyTripBanner isMobile />}
      <Box m={3}>
        {extendData ? <ExtendStay {...extendData} /> : <CrossSellContent />}
      </Box>
      <MarketingTout />
      <Box m={3}>
        <HotelsTonight />
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
    </>
  )
}
